export const LogoMark = ({ size = 32, className = "" }) => (
  <img
    src="/logo-mark.png"
    width={size}
    height={size}
    alt="OPERA360 logo mark"
    className={`rounded-full ${className}`}
  />
);

export const Logo = ({ size = 34 }) => (
  <span className="flex items-center gap-2.5 select-none">
    <LogoMark size={size} />
    <span className="font-cabinet font-black tracking-tight text-xl leading-none text-slate-900">
      OPERA<span className="text-cadmium">360</span>
    </span>
  </span>
);
